export const isHippaAccount = () => {
  const meta = window.localStorage.getItem('accountMeta');

  if (!meta) {
    return false;
  }

  try {
    const { features } = JSON.parse(meta);

    return features?.hippaCompliance === true;
  } catch (e) {
    return false;
  }
};
